import React, { Component, Context } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { WidgetProps } from "../widgets";
import { IAudioActionDispatches, mapAudioDispatchToProps } from "../../redux/actions/audio";
import { IAudioState, mapAudioStateToProps } from "../../redux/reducers/audio";
import { ISiteAudioContent, IEditableWidget } from "../../models/cms";
import AudioPlayer from "./AudioPlayer";
import { IAudioFile } from "../../models/audio";

class AudioWidget extends Component<IAudioActionDispatches & IAudioState & WidgetProps & IEditableWidget> {
	componentDidMount() {
		if (!this.props.editWidget) this.props.loadAudioFile();
	}

	render() {
		const audioFilesConfig: ISiteAudioContent =
			this.props.editWidget || (this.props.audioFilesMap ? this.props.audioFilesMap[this.props.page.id] : null);
		if (!audioFilesConfig) return null;
		const editable: boolean = !!this.props.editWidget;
		console.log("audio loaded:", audioFilesConfig);

		return (
			<div className="w-100 position-relative">
				<div
					className={clsx(
						!this.props.isNested && "container",
						!this.props.page?.noPadding && "section-padding",
						"white-side-right1 position-relative"
					)}
				>
					<h1
						className={clsx(
							"mb-2",
							audioFilesConfig.title && "highlighted mb-5",
							editable && "cms-editable-field"
						)}
						contentEditable={editable}
						data-cms-field="title"
						onBlur={this.props.onInput}
					>
						{audioFilesConfig.title}
					</h1>
					<div>
						{(audioFilesConfig.files || []).map((audio: IAudioFile, i: number) => {
							return (
								<div key={i} className="mb-4_5 last-no-margin">
									<AudioPlayer
										{...audio}
										editWidget={this.props.editWidget}
										onInput={this.props.onInput}
										cmsField={`files[${i}]`}
									/>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		);
	}
}

export default connect<IAudioState, IAudioActionDispatches>(mapAudioStateToProps, mapAudioDispatchToProps)(AudioWidget);
